export const not_existing_project_store_message = '멤버십 운영이 중지된 크리에이터샵 입니다.';
